import { render, staticRenderFns } from "./AnnouncementDetails.vue?vue&type=template&id=caed56d6&scoped=true&"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caed56d6",
  null
  
)

export default component.exports